import actions from '../action/recharge'
import CONSTANT from '../constant/recharge'
import _ from 'underscore'

const recommendProduct = []

export default {
  actions,
  state: {
    rechargeList: [],
    recommendProduct,
  },
  mutations: {
    [CONSTANT.RECHARGE_GET_DETAIL_SUCCESS](state, res) {
      return state.rechargeList.push(res)
    },
    [CONSTANT.RECHARGE_GET_DETAIL_ERROR](state, e) {
      return
    },
    [CONSTANT.RECHARGE_GET_DETAIL_ERROR_EMPTY](state, e) {
      return
    },
    [CONSTANT.RECHARGE_GET_RECOMMEND_LIST_SUCCESS] (state, data) {
      state.recommendProduct= data.data.list
      return state
    },
    [CONSTANT.RECHARGE_GET_RECOMMEND_LIST_ERROR] (state, data) {
      state.recommendProduct = []
      return state
    },
    [CONSTANT.RECHARGE_GET_RECOMMEND_LIST_EMPTY] (state) {
      state.recommendProduct = []
      return state
    },
  },
  getters: {
    [CONSTANT.RECHARGE_GETTER_RECOMMEND_LIST] (state, getters, rootState) {
      return state.recommendProduct
    },
  }
}
